import { jsx as _jsx } from "react/jsx-runtime";
import { createColumnHelper } from '@tanstack/react-table';
import { ModuleOrApplicationLinkRenderer } from '../ModulesDependencies/renderers/ModuleOrApplicationLinkRenderer';
import { RemoteConsumesFilesLinksRenderer } from './RemoteConsumesFilesLinksRenderer';
const columnHelper = createColumnHelper();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const configureColumnDefs = (organization, project, application)=>{
    if (!organization || !project) {
        return [];
    }
    return [
        columnHelper.accessor((row)=>row, {
            id: 'name',
            header: ()=>'Name',
            cell: (inf)=>/*#__PURE__*/ _jsx(ModuleOrApplicationLinkRenderer, {
                    organization: organization,
                    project: project,
                    application: application,
                    value: inf.getValue().name
                })
        }),
        columnHelper.accessor((row)=>row, {
            id: 'file',
            header: ()=>'File',
            cell: (inf)=>/*#__PURE__*/ _jsx(RemoteConsumesFilesLinksRenderer, {
                    value: inf.getValue().file
                })
        })
    ];
};
export const convertToRowData = (module)=>{
    const consumedBy = Array.isArray(module.consumedBy) ? module.consumedBy : [];
    return consumedBy.map((consumeItem)=>{
        var _ref, _consumeItem_name, _consumeItem_usedIn;
        return {
            name: (_ref = (_consumeItem_name = consumeItem.name) !== null && _consumeItem_name !== void 0 ? _consumeItem_name : consumeItem.applicationID) !== null && _ref !== void 0 ? _ref : '',
            file: ((_consumeItem_usedIn = consumeItem.usedIn) !== null && _consumeItem_usedIn !== void 0 ? _consumeItem_usedIn : []).map((usedInItem)=>{
                var _usedInItem_file, _usedInItem_url;
                return {
                    name: (_usedInItem_file = usedInItem.file) !== null && _usedInItem_file !== void 0 ? _usedInItem_file : '',
                    url: (_usedInItem_url = usedInItem.url) !== null && _usedInItem_url !== void 0 ? _usedInItem_url : ''
                };
            })
        };
    });
};
